export const COMMON_CLASSES_FOR_CARD = "w-80 flex-none shadow-none";
